import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import footerLogo from "../assets/Logos/nav-logo.jpeg";

const Footer = () => {
  const usefulLinks = [
    { name: "Home", to: "/" },
    { name: "About Us", to: "/about" },
    { name: "Services", to: "/services" },
    { name: "Careers", to: "/careers" },
    { name: "Contact Us", to: "/contact" },
  ];

  const serviceLinks = [
    { name: "Software Development", to: "/services/#software-development" },
    { name: "IOT", to: "/services/#iot" },
    { name: "Software Consulting", to: "/services/#software-consulting" },
    { name: "Artificial Intelligence", to: "/services/#artificial-intelligence" },
  ];

  return (
    <footer className="bg-[#DFF2FF] text-black pt-10 font-roboto bottom-0 justify-text">
      <div className="container mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        
        <div>
          <Link to="/" className="inline-block mb-4">
            <img
              src={footerLogo}
              alt="Footer Logo"
              className="w-[40vw] md:w-[15vw] h-auto object-contain mix-blend-multiply"
            />
          </Link>

          <p className="text-sm md:text-md">
            Expectations are to deliver cost-effective, high-quality, and
            customer-oriented services on time.
          </p>

        
          <a
  href="https://www.linkedin.com/company/esmob-technologies-private-limited/posts/?feedView=all"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#2584C6] transition-colors mt-4"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#FFFFFF"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 
        2.76 2.24 5 5 5h14c2.76 0 5-2.24 
        5-5v-14c0-2.76-2.24-5-5-5zm-11.75 
        19h-2.5v-9h2.5v9zm-1.25-10.28c-.8 
        0-1.45-.65-1.45-1.44s.65-1.44 
        1.45-1.44c.8 0 1.45.65 
        1.45 1.44s-.65 1.44-1.45 
        1.44zm13 10.28h-2.5v-4.5c0-1.08-.92-2-2-2s-2 
        .92-2 2v4.5h-2.5v-9h2.5v1.22c.62-.9 
        1.67-1.22 2.5-1.22 1.93 0 3.5 1.57 
        3.5 3.5v5.5z"/>
  </svg>
</a>

        </div>

        <div>
          <h4 className="text-lg font-semibold mb-4">Useful Links</h4>
          <ul className="list-disc list-inside text-sm text-gray-900 space-y-2">
            {usefulLinks.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.to}
                  className="hover:text-[#2584C6] hover:font-semibold"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold mb-4">Our Services</h4>
          <ul className="list-disc list-inside text-sm text-gray-900 space-y-2">
            {serviceLinks.map((link, index) => (
              <li key={index}>
                <HashLink
                  smooth
                  to={link.to}
                  className="hover:text-blue-800 hover:font-semibold"
                >
                  {link.name}
                </HashLink>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
          <address className="text-sm not-italic leading-relaxed">
            Level 4, Krishe Emrald, Survey No. 11, <br />
            Kondapur Main Road, Laxmi Cyber City, <br />
            Whitefields, Kondapur, Hyderabad – 500081. <br /><br />
            <strong>Phone:</strong> +91 40 – 40358 20055 <br />
            <strong>Email:</strong>{" "}
            <a
              href="mailto:info@esmobtechnologies.com"
              className="text-blue-800 hover:underline"
            >
              info@esmobtechnologies.com
            </a>
          </address>
        </div>
      </div>

      <div className="bg-[#2584C6] mt-10 py-4 shadow-md">
        <div className="container mx-auto px-4 text-center text-sm md:text-md text-white">
          &copy; {new Date().getFullYear()} ESMOB Technologies Pvt. Ltd. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;